import { Component, OnInit, Input } from '@angular/core';
import { Book } from '../../../../../../shared/models/book';
import { EditorService } from '../../../../../bookeditoption/editor.service';
@Component({
  selector: 'app-videogallerymedia',
  templateUrl: './videogallerymedia.component.html',
  styleUrls: ['./videogallerymedia.component.css']
})
export class VideogallerymediaComponent implements OnInit {
  @Input() data: any;
  public bookObj: Book;
  videoThumbUrl;
  constructor(private editorService: EditorService) {

  }

  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    let cardData = this.editorService.textInlineData;
    if (cardData && (cardData.type == "VIDEO" || cardData.type == "VIDEOYT")) {
      this.initializeData(cardData);
    }
  }
  initializeData(data) {
    if (data && data.props && data.props.videoFile && data.props.videoFile.thumbUrl) {
      this.videoThumbUrl = data.props.videoFile.thumbUrl;
    }
    if (data && data.type == "VIDEO" && data.props && data.props.thumbUrl) {
      this.videoThumbUrl = data.props.thumbUrl;
    }
  }

  getDriveVideo(vObj) {
    // let url = "https://www.youtube.com/watch?v=" + vUrl;
    let layer = this.editorService.getIframeReference();
    // layer.changeVideoSrc(vObj.vUrl, vObj.thumb, vObj.type);
    layer.updateVideoSrc(vObj.vUrl, vObj.type, vObj.thumb)

  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/media/video/videogallerymedia/videogallerymedia.component.ts